module.exports = __webpack_public_path__ + "static/media/active-days-icon.3ab12909.svg";